export default [
    {
      path: '/invoice/:key?',
      name: 'invoice',
      component: () => import('@/views/invoice/InbotInvoiceIndex.vue'),
      meta: {},
    },
    {
      path: '/invoice/gettingStarted',
      name: 'invoiceGettingStarted',
      component: () => import('@/views/invoice/connectMeinvoice/ConnectMISAMeinvoice.vue'),
      meta: {},
    }
  ];
  